
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"65","height":"62","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M47.194 12.785H35.727l5.17 8.46c.01.014.018.028.027.043l4.184 7.274a12.687 12.687 0 016.937-2.056C59.2 26.506 65 32.436 65 39.753 65 47.069 59.2 53 52.045 53s-12.956-5.93-12.956-13.247a13.37 13.37 0 013.169-8.68l-3.58-6.225-13.92 8.49a13.451 13.451 0 011.152 5.468c0 7.317-5.8 13.248-12.955 13.248S0 46.123 0 38.806C0 31.49 5.8 25.56 12.955 25.56c1.352 0 2.656.212 3.882.605l1.804-3.69c-.205-.246-.46-.552-.754-.918-.834-1.038-2.007-2.586-3.603-4.986H8.328c-1.022 0-1.85-.847-1.85-1.892 0-1.046.828-1.893 1.85-1.893h11.105c1.022 0 1.85.847 1.85 1.893 0 1.045-.828 1.892-1.85 1.892h-.628a53.843 53.843 0 001.942 2.584c.318.395.571.697.788.955v.001l.205.245h14.25l-4.906-8.025C30.198 10.88 31.217 9 32.89 9h14.305c1.022 0 1.85.847 1.85 1.893 0 1.045-.828 1.892-1.85 1.892zM15.151 29.612a9.08 9.08 0 00-2.196-.268c-5.11 0-9.254 4.236-9.254 9.462s4.144 9.463 9.254 9.463c5.11 0 9.254-4.237 9.254-9.463a9.624 9.624 0 00-.658-3.512l-7.376 4.499c-1.668 1.017-3.602-.82-2.734-2.595l3.71-7.586zm4.362 2.518l-2.074 1.265 1.06-2.166c.359.275.698.576 1.014.901zm3.248-1.981a13.12 13.12 0 00-2.588-2.345l1.792-3.664h10.648l-9.852 6.009zm21.524 4.447a9.572 9.572 0 00-1.494 5.157c0 5.226 4.143 9.462 9.254 9.462 5.11 0 9.253-4.236 9.253-9.462s-4.142-9.462-9.253-9.462a9.065 9.065 0 00-5.058 1.537l3.19 5.546c.519.9.224 2.06-.657 2.59-.88.53-2.015.23-2.533-.671l-2.702-4.697z","fill":"#24242E"}})])
          )
        }
      }
    